// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { ListPackagesResponse } from '@digitalasset/json-api-ts-client';
import { useQuery } from '@tanstack/react-query';
import { useLedgerApiClient } from '../../../contexts/LedgerApiContext';

export const useLedgerPackageList: () => ListPackagesResponse | undefined = () => {
  const ledgerApi = useLedgerApiClient();
  const ledgerQuery = useQuery({
    queryKey: ['getLedgerPackageList', ledgerApi],
    queryFn: () => ledgerApi.api().getV2Packages(),
  });
  return ledgerQuery.data;
};
